<template>
	<transition name="fade">
		<div v-if="isModalOpen" class="modal">
			<div class="modal__content" :style="{ 'max-width': modalWidth }">
				<div v-if="!unclosable" class="modal__close-btn" data-cy="close-modal-btn" @click.prevent="onClose" />
				<!-- Children will go here -->
				<slot></slot>
			</div>
			<div class="modal__backdrop" @click.prevent="!unclosable && onClose()" />
		</div>
	</transition>
</template>
<script>
export default {
	props: {
		modalSize: {
			type: String,
			default: ''
		},
		isModalOpen: {
			type: Boolean,
			default: false
		},
		onClose: {
			type: Function,
			default: () => true
		},
		unclosable: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		modalWidth() {
			switch (this.modalSize) {
				case 'xxl':
					return '1170px';
				case 'xl':
					return '970px';
				case 'lg':
					return '840px';
				case 'md':
					return '750px';
				default:
					return '100%';
			}
		}
	}
};
</script>
<style lang="scss">
@import '@/styles/mixins/cross.scss';
@import '@/styles/mixins/brand-fonts.scss';

.modal {
	z-index: 1001;
	box-sizing: border-box;
	display: block;
	position: fixed;
	left: 0;
	top: 0;
	width: 100vw;
	height: 100vh;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px 15px 32px;
	@include media-breakpoint-up(md) {
		padding: 24px 53px 42px;
	}
	&__content {
		box-sizing: border-box;
		position: relative;
		z-index: 2;
		width: 100%;
		height: auto;
		max-height: 100%;
		padding: 36px 24px;
		overflow: auto;
		background: $brand-white;

		@include media-breakpoint-up(md) {
			padding: 36px 36px 54px;
		}
		&__header {
			@include Brand-H12();
			text-align: center;
			padding: 36px;
		}
		&__body {
			@include Brand-P3();
			text-align: center;
		}
	}
	&__backdrop {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		height: 100%;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.6);
	}
	&__close-btn {
		@include Cross(16px, $brand-white);
		position: absolute;
		z-index: 3;
		right: 20px;
		top: 20px;
		mix-blend-mode: difference;
		&:after,
		&:before {
			height: 2px;
		}
	}
}

// Classes for defining magical Vue transitions!
// Always follows the pattern of {transition name}-{transition state name}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
